'use client';

import { lazy, Suspense } from 'react';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';

const CartPageClient = lazy(() => import('./cart-page-client'));

export default function CartPageEntry() {
  return (
    <Suspense fallback={<GenericLoader />}>
      <CartPageClient />
    </Suspense>
  );
}
